<template functional>
  <div class="hero-icons -helper--flex justify-center space-between">
    <div
      v-for="item in props.data"
      :key="item.content"
      class="icon-box -helper--flex align-center column"
    >
      <span class="icon-wrapper" :class="item.iconClass" />
      <p class="content-wrapper">{{ item.content }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HeroIcons',
  functional: true,
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/welcome/HeroIcons.vue